import React from "react";
import Typography from "@mui/material/Typography";
import Colors from "./Colors";

function TypographySliderHeading({ onClick, sx, ...props }) {
  return (
    <Typography
      sx={{
        fontFamily: "IBM Plex Sans",
        fontWeight: 600,
        fontSize: { xs: "32px", sm: "32px", md: "64px" },
        color: Colors.black,
        lineHeight: { xs: "34px", sm: "34px", md: "72px" },
        fontStyle: "normal",
        ...sx,
      }}
      {...props}
      onClick={onClick}
    ></Typography>
  );
}

export default TypographySliderHeading;
